if (!customElements.get('tw-wine-credit')) {
  customElements.define('tw-wine-credit', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.variants = JSON.parse(this.querySelector('[data-twp-variants]').textContent);
      this.product = this.closest('[data-js-product-component]');
      this.picker = this.product?.querySelector('product-variants');
      this.update = () => {
        const id = this.picker?.currentVariant?.id || this.product?.querySelector('form input[name="id"]')?.value || this.dataset.selected;
        const variant = this.variants.find(item => String(item.id) === String(id));
        if (!variant) return;
        this.querySelector('[data-credit-tube]').hidden = !variant.tube;
        this.querySelector('[data-credit-bottle]').hidden = variant.tube;
        queueMicrotask(() => {
          const url = new URL(window.location.href);
          if (url.searchParams.get('view') !== 'wine-pdp') {
            url.searchParams.set('view', 'wine-pdp');
            window.history.replaceState({}, '', url);
          }
        });
      };
      this.picker?.addEventListener('VARIANT_CHANGE', this.update, {signal:this.controller.signal});
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
